/** Build a WhatsApp click-to-chat URL with an optional prefilled message. */
export function whatsappHref(e164: string, message?: string) {
  const digits = e164.replace(/\D/g, "");
  if (!digits) return "https://wa.me/";
  if (!message) return `https://wa.me/${digits}`;
  return `https://wa.me/${digits}?text=${encodeURIComponent(message)}`;
}

/** Tel / WhatsApp href for an office phone row. */
export function officePhoneHref(
  phone: { href: string; whatsapp?: boolean },
  message?: string,
) {
  if (phone.whatsapp) return whatsappHref(phone.href, message);
  return `tel:${phone.href}`;
}
